export default function PageHeader({ title, subtitle, eyebrow = "Contabilità Cantiere", actions, children }) {
  return (
    <header className="border-b border-slate-200 pb-6 mb-6">
      <div className="flex items-start justify-between gap-4">
        <div className="flex flex-col items-start gap-1">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500" data-testid="page-eyebrow">
            {eyebrow}
          </span>
          <h1 className="font-heading text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900 leading-none">
            {title}
          </h1>
          {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
        </div>
        {actions && <div className="flex flex-wrap items-center justify-end gap-2 flex-shrink-0">{actions}</div>}
      </div>
      {children && <div className="flex flex-wrap items-center gap-3 mt-4">{children}</div>}
    </header>
  );
}
